import { getMomentTz } from "@dexteel/mesf-core";
import { ColDef } from "ag-grid-community";
import { LinkCellRenderer } from "../../../controls/ag-grid/components/ButtonCellRenderer";

const moment = getMomentTz();
export const useChemistryTableData = () => {
	const columnData: ColDef[] = [
		{
			headerName: "Heat",
			field: "HeatNameValue",
			minWidth: 65,
			cellRenderer: LinkCellRenderer,
			cellRendererParams: { linkProperty: "HeatNameLink" },
			flex: 1,
		},
		{
			headerName: "Grade",
			field: "Grade",
			minWidth: 80,
			flex: 1,
		},
		{
			headerName: "Sample",
			field: "Sample",
			minWidth: 69,
			flex: 1,
		},
		{
			headerName: "Elements",
			field: "Elements",
			minWidth: 80,
			wrapText: true,
			autoHeight: true,
			flex: 4,
		},
		{
			headerName: "Compatible Grades",
			field: "CompatibleGrades",
			minWidth: 140,
			flex: 2,
		},
		{
			headerName: "Results Time",
			field: "ResultsTime",
			minWidth: 110,
			valueGetter: (params) =>
				moment(params.data?.ResultsTime).format("MM/DD HH:mm") || "",
			flex: 1,
		},
		{
			headerName: "Technician",
			field: "LabTechnician",
			minWidth: 90,
			flex: 1,
		},
		{
			headerName: "Comments",
			field: "Comments",
			minWidth: 100,
			flex: 1,
		},
	];

	const defaultColDef: ColDef = {
		flex: 1,
		resizable: true,
		suppressHeaderMenuButton: true,
		autoHeight: true,
		wrapText: true,
	};

	return { columnData, defaultColDef };
};
